import { render, staticRenderFns } from "./ArchivosMultiples.vue?vue&type=template&id=a164ef58&"
import script from "./ArchivosMultiples.vue?vue&type=script&lang=js&"
export * from "./ArchivosMultiples.vue?vue&type=script&lang=js&"
import style0 from "./ArchivosMultiples.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports